import api from '@/api'

export default {
  state: {
    categoryByAssetsType: {
      bms: 'bridges',
      rams: 'roads'
    }
  },
  actions: {
    // LOAD_FEATURES_STRUCTS loads array of features with their actions
    async LOAD_FEATURES_STRUCTS() {
      try {
        const {status, data} = await api.permissions.load_features_structs()
        if (status === 200) {
          return data
        } else {
          throw `Load features structs error, code:${data}`
        }
      } catch (err) {
        throw err
      }
    }
  },
  mutations: {},
  getters: {}
}
